export default "__VITE_ASSET__C$vx8Jcx__"